import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatStepper } from "@angular/material/stepper";
import { ServiceRequestService } from "@core/services/service-request.service";
import { ServicesTypeService } from "@core/services/services-type.service";
import { ServiceTypeEnum } from "@shared/enums/service-type-enum";
import { VehicleModelCategoriesEnum } from "@shared/enums/vehicle-model-categories.enum";
import { NearbyHistoryCarWorkshopDTO } from "@shared/models/nearby-history-car-workshop-dto";
import { PeriodDTO } from "@shared/models/period-dto";
import { ServicesProvidedDTO } from "@shared/models/services-provided-dto";
import * as _ from "lodash";

interface PropsType {
  clientId?: number;
  vehicleId?: number;
  carWorkshopId?: number;
  view: string;
  serviceType: string;
  vehicleCategory: string;
  isPuc: boolean;
  isBackofficeUserLogged?: boolean;
  daysAdvanceForAppointments: number;
}

@Component({
    selector: "app-driveb-reschedule-modal",
    templateUrl: "./reschedule-modal.component.html",
    styleUrls: ["./reschedule-modal.component.scss"],
    standalone: false
})
export class RescheduleModalComponent implements OnInit {
  @ViewChild("stepper") stepper: MatStepper;

  form = this.fb.group({
    date: ["", [Validators.required]],
    period: ["", [Validators.required]]
  });

  formCarworkshopSpecialty = this.fb.group({
    serviceCategories: [{ value: null, disabled: true }, [Validators.required]],
    servicesProvided: [{ value: null, disabled: true }, [Validators.required]]
  });

  isLightVehicle: boolean;
  heavyServicesProvided: ServicesProvidedDTO[] = [];
  servicesCategories = [];
  canSearchCarworkshop = false;

  unavailableDatesPeriods = [];
  periods: PeriodDTO[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: PropsType,
    private matDialogRef: MatDialogRef<RescheduleModalComponent>,
    private fb: UntypedFormBuilder,
    private serviceRequestService: ServiceRequestService,
    private servicesTypeService: ServicesTypeService
  ) {}

  async ngOnInit(): Promise<void> {
    await this.getPeriods();
    await this.getUnavailableDatesPeriods(
      this.data.carWorkshopId,
      this.data.serviceType === ServiceTypeEnum.PREVENTIVE
        ? this.data.isPuc || false
        : false
    );

    if (this.data.serviceType == ServiceTypeEnum.CORRECTIVE) {
      this.isLightVehicle =
        this.data.vehicleCategory === VehicleModelCategoriesEnum.RIDE ||
        this.data.vehicleCategory === VehicleModelCategoriesEnum.PICKUP;

      if (this.isLightVehicle) {
        this.formCarworkshopSpecialty.get("serviceCategories").enable();
        this.formCarworkshopSpecialty.get("servicesProvided").disable();

        const res = await this.servicesTypeService
          .getServiceCategories()
          .toPromise();
        this.servicesCategories = res.filter(
          (service: any) => service.id != 5 && service.id != 6
        );
      } else {
        this.formCarworkshopSpecialty.get("serviceCategories").disable();
        this.formCarworkshopSpecialty.get("servicesProvided").enable();
        this.heavyServicesProvided = await this.servicesTypeService
          .filter({ categoryCode: "HEAVY" })
          .toPromise();
      }
    } else {
      this.canSearchCarworkshop = true;
    }

    if (this.data.view == "CHANGE_CAR_WORKSHOP_MODAL") {
      this.stepper._getIndicatorType = () => "number";
      this.form.addControl(
        "carWorkshopId",
        this.fb.control("", Validators.required)
      );
    }
  }

  onStepChange(event: any): void {
    if (event.selectedIndex == 1) {
      this.canSearchCarworkshop = true;
    }
  }

  async getUnavailableDatesPeriods(
    carWorkshopId: number,
    isPuc: boolean
  ): Promise<void> {
    try {
      this.unavailableDatesPeriods = await this.serviceRequestService
        .unavailable(carWorkshopId, isPuc)
        .toPromise();
    } catch (error) {
      this.unavailableDatesPeriods = [];
    }
  }

  async getPeriods(): Promise<void> {
    try {
      this.periods = await this.serviceRequestService
        .listAllTypePeriod()
        .toPromise();
    } catch (error) {
      this.periods = [];
    }
  }

  setNewDatePeriod(event): void {
    this.form.patchValue(event);
  }

  getInputData(): PropsType {
    return this.data;
  }

  async handleCarWorkshopChange(
    carWorkshop: NearbyHistoryCarWorkshopDTO
  ): Promise<void> {
    if (_.isEmpty(carWorkshop)) {
      return;
    }

    this.form.get("carWorkshopId").setValue(carWorkshop.id);
    this.getUnavailableDatesPeriods(
      this.form.get("carWorkshopId").value,
      this.data.serviceType === ServiceTypeEnum.PREVENTIVE
        ? this.data.isPuc
        : false
    );
  }

  closeDialog(): void {
    this.matDialogRef.close();
  }

  submit(): void {
    this.matDialogRef.close(this.form.value);
  }
}
